import { render, staticRenderFns } from "./AccessKeyModal.vue?vue&type=template&id=bf2500d2&scoped=true"
import script from "./AccessKeyModal.vue?vue&type=script&lang=ts"
export * from "./AccessKeyModal.vue?vue&type=script&lang=ts"
import style0 from "./AccessKeyModal.vue?vue&type=style&index=0&id=bf2500d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2500d2",
  null
  
)

export default component.exports